module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-contact"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6e96856f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e96856f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Contact/index.vue
// module id = 864
// module chunks = 0